import { BaseClient } from '~domain/api-clients/base-client';
import { RequestErrorHandler } from '~domain/api-clients/request-error-handlers/base-request-error-handler';

/**
 * Create the requested client - All frontend services should use this loader when creating a Client
 * The
 * @param url baseUrl of client
 * @param headers header to create the client with
 * @param requestErrorHandler error handle that will be used by Client object
 */
export function loadServerClient<T extends BaseClient>(
  t: new (url: string, headers: object, requestErrorHandler?: RequestErrorHandler) => T,
  url: string,
  requestErrorHandler?: RequestErrorHandler,
): T {
  // Create the client
  const client: T = new t(url, {}, requestErrorHandler);

  return client;
}
